import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'pcm-component',
  templateUrl: 'pcm.component.html',
  styleUrls: ['pcm.component.scss'],
})
export class PcmComponent implements OnDestroy {
  @ViewChild('iframe', { static: true }) iframe: ElementRef;

  @Input() public url = '';

  @Output() public onCodeSelected: EventEmitter<any> = new EventEmitter<any>();

  @Output() public onUploaded: EventEmitter<boolean> = new EventEmitter<boolean>();

  subscription: Subscription;

  constructor() {
    this.subscription = fromEvent(window, 'message')
      .pipe(
        filter((messageEvent: MessageEvent) => messageEvent.data && messageEvent.data.channel === 'codesPCM'),
        map((messageEvent: MessageEvent) => messageEvent.data.message),
      )
      .subscribe((res) => {
        this.onCodeSelected.emit(res);
      });
  }

  uploadDone() {
    this.onUploaded.emit(true);
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
